import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { type LabelProps } from './types';
import { StyledLabelContainer, StyledLabelText } from './styles';
const Label = props => {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.text) {
    t0 = <StyledLabelText variant="h4">{props.text}</StyledLabelText>;
    $[0] = props.text;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.color || $[3] !== t0) {
    t1 = <StyledLabelContainer color={props.color}>{t0}</StyledLabelContainer>;
    $[2] = props.color;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
export default Label;
export type { LabelColor } from './types';
export { Label };